// NOTE: bump the version number in vite.config.ts when updating this file

declare global {
  var Cookiebot: any;
}

function superchatCB() {
  // Load if: no cookie consent tool needed OR preferences are consented
  if (!document.getElementById('Cookiebot') || window.Cookiebot?.consent?.preferences) {
    const id = 'superchat-script';
    if (document.getElementById(id)) {
      return;
    }
    const key = document
      .querySelector<HTMLScriptElement>('script[data-key][src*="/superchat-"]')
      ?.dataset?.key?.trim();
    if (!key) {
      console.error('missing superchat key');
      return;
    }
    const script = document.createElement('script');
    script.setAttribute('id', id);
    script.setAttribute('defer', 'defer');
    script.setAttribute('src', `https://widget.superchat.de/snippet.js?applicationKey=${key}`);
    script.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    script.onerror = () => console.error('Superchat failed to load');
    document.head.appendChild(script);
  }
}
superchatCB();
window.addEventListener('CookiebotOnAccept', superchatCB);
